import React from 'react'

const Spinner = () => {
  return (
    <div className='flex justify-center items-center' >
        <h1 className='w-full h-screen  text-3xl font-bold flex justify-center items-center '>Loading...
            <div className='loader left-3'> </div>
        </h1>
        
        
     
    </div>
  )

}

export default Spinner
